import { useState, useEffect, useRef } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import PopUp from "../../PopUp/PopUp";
import SelectionList from "../../List/SelectionList";
import ViewCard from "../../List/ViewCard";

import "./style.css";
import axios from "axios";
import {
  disabledIfFieldChecker,
  extractDataOO,
  findDataInFields,
} from "../../../utils/helperFuctions";
import { config } from "../../../utils/config";
import { PropagateLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { getCookie, setCookie } from "../../../utils/cookieHandler";
import { XMarkIcon } from "@heroicons/react/20/solid";

const InputSelectionPopup = ({
  label,
  name,
  id,
  placeholder,
  defaultValue,
  err,
  handleChange,
  url,
  returnParameter,
  toShow,
  data,
  isSearchable,
  statusColors,
  searchPlaceholder,
  filters,
  dependson,
  required,
  fields,
  disabled,
  disabledIfField,
  removeValueOnWhichFieldValueChange,
  dataParam,
}) => {
  const xMarkRef = useRef(null);
  const currentFields = useSelector((state) => state.showFields);
  const branchDefaultValue = findDataInFields(
    currentFields,
    removeValueOnWhichFieldValueChange
  );
  const [fieldDefaultValue, setFieldDefaultValue] = useState(
    branchDefaultValue || null
  );

  const [value, setValue] = useState(
    defaultValue
      ? typeof defaultValue === "object"
        ? defaultValue.id
        : defaultValue
      : ""
  );

  useEffect(() => {
    if (fieldDefaultValue !== branchDefaultValue) {
      if (xMarkRef.current != null) {
        xMarkRef.current.click();
        setFieldDefaultValue(branchDefaultValue);
      }
    }
  }, [branchDefaultValue]);

  const [tempValue, setTempValue] = useState("");
  const [showValue, setShowValue] = useState("");

  const [popupData, setpopupData] = useState({ showPopUp: false });
  const [dependant, setDependant] = useState({
    flag: Array.isArray(dependson),
    show: false,
    mesaage: "",
  });

  const initTempValue = () => {
    if (data && Array.isArray(data)) {
      const listData = toShow ? extractDataOO(data, toShow) : data;

      if (returnParameter) {
        const checkwith =
          typeof defaultValue === "object" ? defaultValue.id : defaultValue;
        const temp = listData.find((x) => x[returnParameter] == checkwith);
        setShowValue(temp ? temp : defaultValue);
      } else {
        setShowValue(defaultValue);
      }
    } else {
      getDefaultFromDatabase();
    }
  };

  const getDefaultFromDatabase = () => {
    try {
      const checkwith =
        typeof defaultValue === "object" ? defaultValue.id : defaultValue;
      axios
        .get(`${config.apiUrl}/api/${url}/${checkwith}`, {
          headers: { Authorization: `Bearer ${getCookie("_AT")}` },
        })
        .then((resp) => {
          if (resp.headers?.authorization) {
            if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
              setCookie("_AT", resp.headers.authorization.split(" ")[1]);
            }
          }
          if (resp && resp.data) {
            const manipulatedData = extractDataOO([resp.data], toShow);

            setShowValue(
              toShow
                ? Array.isArray(manipulatedData) && manipulatedData.length > 0
                  ? manipulatedData[0]
                  : resp.data
                : resp.data
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (error) {
      // Handle the error here if needed
      console.error(`Error fetching data for ${name}:`, error);
    }

    return [];
  };

  const handleInputChange = (e) => {
    setTempValue(e);
  };
  const handleInputChanged = (e) => {
    console.log("tempValue: ");
    const newValue = returnParameter ? tempValue[returnParameter] : tempValue;
    if (tempValue) {
      console.log(tempValue);

      setShowValue(tempValue);
      setValue(newValue);
      setTempValue("");
      const modifiedEvent = {
        target: {
          name: name,
          value: {
            id: newValue,
            class: tempValue?.classId
              ? {
                  id: tempValue.classId || 0,
                }
              : tempValue?.id
              ? { id: tempValue.id }
              : "",
          },
        },
      };
      handleChange(modifiedEvent);
    }
  };
  const handleClick = (e) => {
    if (isFieldDisabled === true) {
      return;
    }
    e.preventDefault();
    setpopupData({ showPopUp: true });
  };
  const hidePopUp = () => {
    setpopupData({});
  };

  useEffect(() => {}, [value]);

  useEffect(() => {
    if (defaultValue && (!showValue || showValue === "")) {
      initTempValue();
    }
  }, []);

  useEffect(() => {
    let message = "The following fields must have values: ";

    if (currentFields && Array.isArray(dependson)) {
      let testFlag = dependson.length;
      dependson.forEach((dep) => {
        const index = currentFields.findIndex((x) => x.name === dep);
        if (index !== -1) {
          if (
            currentFields[index].defaultValue === null ||
            currentFields[index].defaultValue === undefined ||
            currentFields[index].defaultValue === ""
          ) {
            message += currentFields[index].label + ", ";
          } else {
            testFlag--;
          }
        }
      });
      if (testFlag === 0 && dependson.length > 0) {
        setDependant((prev) => {
          return { ...prev, mesaage: message, show: true };
        });
      } else {
        setDependant((prev) => {
          return { ...prev, mesaage: message, show: false };
        });
      }
    }
  }, [currentFields]);

  const addFilters = (filters) => {
    if (filters) {
      let concatFilters = "";
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const element = filters[key];

          if (element.includes("<s>")) {
            concatFilters += key + "=" + element.replace("<s>", "") + "&";
          } else if (element.includes("<now>")) {
            concatFilters += key + "=" + new Date().toISOString() + "&";
          } else {
            concatFilters +=
              key +
              "=" +
              encodeURIComponent(findDataInFields(currentFields, element)) +
              "&";
          }
        }
      }

      return concatFilters;
    }

    return "";
  };

  const clearVehicle = (e) => {
    if (e) {
      e.preventDefault();
    }
    //setValue("");
    const modifiedEvent = {
      target: {
        name: name,
        value: "",
      },
    };
    setValue("");
    handleChange(modifiedEvent);
  };

  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;
  return (
    <>
      <div>
        {label && (
          <label
            htmlFor={name}
            className="block text-sm font-medium leading-6 text-gray-900 text-left"
          >
            {label}
            {required ? "*" : ""}
          </label>
        )}
        {!value && (
          <button
            type="button"
            className="relative mt-2 block w-full rounded-lg border-2 border-dashed border-gray-300 p-8 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            onClick={handleClick}
          >
            <PlusIcon className="mx-auto h-12 w-12 text-gray-400" />
            <span className="mt-2 block text-sm font-semibold text-gray-900">
              {placeholder || "Add"}
            </span>
          </button>
        )}
        {value &&
          showValue &&
          (value == showValue || value == showValue[returnParameter]) && (
            <div className="viewcard border-gray-300 rounded-lg bg-white text-center shadow relative">
              <ViewCard
                isFieldDisabled={isFieldDisabled}
                data={showValue}
                statusColors={statusColors}
                onClick={handleClick}
                display={true}
              />
              {/* <div className="change absolute w-full h-full  top-0 border-gray-300 rounded-lg flex justify-center items-center">
                <button
                  type="button"
                  style={{
                    position: "absolute",
                    bottom: "5px",
                    left: "5px",
                    cursor: isFieldDisabled ? "not-allowed" : "pointer",
                  }}
                  disabled={isFieldDisabled}
                  className={
                    "inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                  }
                  onClick={handleClick}
                >
                  Change
                </button>
              </div> */}
              <button
                ref={xMarkRef}
                onClick={clearVehicle}
                disabled={isFieldDisabled}
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  borderRadius: "50%",
                  cursor: isFieldDisabled ? "not-allowed" : "pointer",
                }}
                className=" p-1 bg-primary hover:bg-blue-600 focus:outline-none"
              >
                <XMarkIcon className="w-4 h-4 text-white" />
              </button>
            </div>
          )}
        {value && !showValue && (
          <div className="w-full text-center">
            <PropagateLoader color="#0167ff" />
          </div>
        )}
      </div>
      {err && <p className="mt-2 text-sm text-red-600">{err}</p>}
      <PopUp
        title={placeholder}
        showPopUp={popupData.showPopUp}
        hidePopUp={hidePopUp}
        propName={name}
        takeActionFun={handleInputChanged}
        width="min-w-0.8"
        height="60%"
      >
        {dependant.show && (
          <SelectionList
            dataParam={dataParam}
            data={data}
            searchable={isSearchable}
            searchPlaceholder={searchPlaceholder}
            propertyName={name}
            url={url}
            handleChange={handleInputChange}
            toShow={toShow}
            statusColors={statusColors}
            filters={addFilters(filters)}
          />
        )}
        {!dependant.show && <p>{dependant.mesaage}</p>}
      </PopUp>
    </>
  );
};

export default InputSelectionPopup;
